export default __webpack_public_path__ + "static/media/person.17f39536.jpg";